import { IconContactNewsComponent } from '@vaad1st/component.atom.icons';
import {
  TypographyComponent,
  TypographySize,
  TypographyWeight,
} from '@vaad1st/component.atom.typography';
import HTMLRenderer from '../html-renderer/html-renderer.component';
import styles from './alert-card.component.module.less';

export interface AlertCardProps {
  lastUpdated: string;
  path: string;
  title: string;
  className?: string;
}

export default function AlertCard(props: AlertCardProps) {
  const { title, lastUpdated, path, className = '' } = props;

  return (
    <div className={`${styles['alert-card']} ${className}`}>
      <article>
        <div className={styles['alert-card__accent']}></div>
        <div className={styles['alert-card__icon']}>
          <IconContactNewsComponent />
        </div>
        <div className={styles['alert-card__content']}>
          <div className={styles['alert-card__title']}>
            <TypographyComponent
              as="h3"
              size={TypographySize.Mdm}
              weight={TypographyWeight.Normal}>
              <a href={path}>
                <span>{title}</span>
              </a>
            </TypographyComponent>
          </div>
          <div className={styles['alert-card__last-updated']}>
            <TypographyComponent size={TypographySize.Xxs}>
              Last updated{' '}
              <HTMLRenderer htmlString={lastUpdated}></HTMLRenderer>
            </TypographyComponent>
          </div>
        </div>
      </article>
    </div>
  );
}
